import React from 'react';
import ReactGA from 'react-ga4';

const Content = () => {
  return (
    <>
      <div className="popup-content-title">
        <h3>South Melbourne Sewer Upgrade – Market Street Pump Station</h3>
      </div>
      <div className="popup-content-source">
        <p className="bold">
          A new pump station will be built as part of stage 2 of the South
          Melbourne Sewerage Capacity Upgrade.
        </p>
        <p>
          For more information click{' '}
          <a
            href="https://southeastwater.com.au/southmelbourne"
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              ReactGA.event({
                category: `Map – Major Projects (orange)`,
                action: '<a href> link',
                label:
                  'MORE INFO: South Melbourne Sewer Upgrade – Market Street Pump Station',
              });
            }}
          >
            here
          </a>{' '}
          or contact the project team at{' '}
          <a href="tel:1800728256">1800 728 256</a> |{' '}
          <a
            href="mailto:southmelbourne@sew.com.au"
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              ReactGA.event({
                category: `Map - Major Projects (orange)`,
                action: 'Email link',
                label:
                  'MAIL TO: engagement@sew.com.au: South Melbourne Sewer Upgrade – Market Street Pump Station',
              });
            }}
          >
            southmelbourne@sew.com.au
          </a>
        </p>
      </div>
    </>
  );
};

export default Content;
